import { memo, type ReactNode } from 'react';

export type PrivateBoardSearchHeaderProps = {
  title: string;
  rightAdornment?: ReactNode;
};

export const PrivateBoardSearchHeader = memo(({ title, rightAdornment }: PrivateBoardSearchHeaderProps) => {
  return (
    <div className="mb-2 flex h-6 content-between items-center">
      <div className="flex-1">
        <h2 className="ml-1 font-bold text-12 text-pigeon-500 uppercase">{title}</h2>
      </div>
      {rightAdornment}
    </div>
  );
});

PrivateBoardSearchHeader.displayName = 'PrivateBoardSearch';
